import "./SiteFooter.module.css";

export default function SiteFooter() {
    return (
        <footer className={"site-footer"}>
            <div className={"site-footer__inner"}>
                <p className={"site-footer__text"}>&copy; {new Date().getFullYear()} Animotive Limited. All Rights Reserved.</p>
            </div>
        </footer>
    );
}
